<template>
	<div class="product-list">
		<div class="product-list-header" @click="productListClick">
			<div class="header-icon"></div>
			<span class="header-title">{{ title }}</span>
			<span class="header-more">更多</span>
		</div>
		<div class="product-list-body">
			<index-product-body
				:item="item"
				:index="index"
				v-for="(item, index) in items"
				v-bind:key="index"
			></index-product-body>
		</div>
	</div>
</template>

<script>
import IndexProductBody from './IndexProductBody'

export default {
  name: 'IndexProductList',
  data () {
    return {}
  },
  props: ['items', 'title', 'type'],
  components: {
    IndexProductBody
  },
  computed: {

  },
  methods: {
    productListClick: function () {
      this.$router.push({
        name: 'HomeGoodslist',
        query: { sort_key: this.type }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.product-list {
	background: #ffffff;
	margin-top:$modelSpace;
	.product-list-header {
		display: flex;
		height:2rem;
		padding: 0 $pageSpace;
		justify-content: space-between;
		align-items: center;
		margin-bottom:.5rem;
		.header-title {
			font-size:$mainFontSize;
			color: #000;
			font-weight:700;
		}
		.header-icon {
			width:1rem;
			height:1rem;
		}
		.header-more{
			font-size:$fontSize;
			color:$descTextColor;
		}
	}
	.product-list-body {
		display: flex;
		flex-wrap: wrap;
		padding-right: $pageSpace;
	}
}
</style>
